import React from "react";
import styles from "./Security.module.scss";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../PrivateRoute/PrivateRoute";
import { profileChangeData } from "../../../api/userApi";
import { useNotification } from "../../../contexts/NotificationToast";

const Security = () => {
  const { t } = useTranslation();
  const { userData, setUserData } = useAuth();
  const { showNotification } = useNotification();

  const handleCheckboxChange = async (e) => {
    const isChecked = e.target.checked;

    try {
      await profileChangeData({ notifications_enabled: isChecked });
      setUserData((prevData) => ({
        ...prevData,
        notifications_enabled: isChecked,
      }));
      showNotification("Newsletter subscription changed", 200);
    } catch (error) {
      showNotification("Failed to change newsletter subscription", 500);
    }
  };
  return (
    <div>
      <h2 className={styles.title}>{t("security.title")}</h2>
      <div className={styles.securityContent}>
        <div className={styles.contentItem}>
          <h3>{t("security.newsletter.header")}</h3>
          <div className={styles.newsChechboxConteiner}>
            <input
              type="checkbox"
              checked={userData?.notifications_enabled}
              onChange={handleCheckboxChange}
            />
            <p>{t("security.newsletter.description")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
